import React from "react";
import { TrendingUp } from "lucide-react";
import "../../styles/statsCard.css";

export default function StatsCard({
  title,
  value,
  icon: Icon,
  trend,
  variant = "primary",
}) {
  const styles = {
    primary: {
      gradient: "linear-gradient(135deg, #0A4D68 0%, #088395 100%)",
      iconBg: "rgba(10, 77, 104, 0.1)",
      iconColor: "var(--primary)",
    },
    accent: {
      gradient: "linear-gradient(135deg, #F2A154 0%, #FFD699 100%)",
      iconBg: "rgba(242, 161, 84, 0.1)",
      iconColor: "var(--accent)",
    },
    success: {
      gradient: "linear-gradient(135deg, #059669 0%, #10B981 100%)",
      iconBg: "rgba(5, 150, 105, 0.1)",
      iconColor: "#059669",
    },
    revenue: {
      gradient: "linear-gradient(135deg, #7C3AED 0%, #A78BFA 100%)",
      iconBg: "rgba(124, 58, 237, 0.1)",
      iconColor: "#7C3AED",
    },
  };

  const style = styles[variant] || styles.primary;

  return (
    <div className="stats-card fade-in">
      <div className="stats-top">
        <div>
          <p className="stats-title">{title}</p>
          <h3 className="stats-value">{value}</h3>
        </div>

        <div
          className="stats-icon"
          style={{ background: style.iconBg }}
        >
          <Icon size={22} color={style.iconColor} />
        </div>
      </div>

      {trend && (
        <div className="stats-trend">
          <TrendingUp size={14} />
          <span>{trend}</span>
        </div>
      )}
    </div>
  );
}
